import { defineChain } from 'viem';

export const goatTestnet = defineChain({
    id: 48816,
    name: 'GOAT TESTNET',
    nativeCurrency: {
        decimals: 18,
        name: 'Bitcoin',
        symbol: 'BTC',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet3.goat.network'],
            webSocket: ['https://rpc.testnet3.goat.network'],
        },
        public: {
            http: ['https://rpc.testnet3.goat.network'],
            webSocket: ['https://rpc.testnet3.goat.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://explorer.testnet3.goat.network',
        },
    },
});
